import type { SerializedHardware } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import type { DeleteHardwareArg } from 'lib/services';
import { useMutation, type UseMutationResult } from 'react-query';
import { notifyError, notifySuccess } from 'utils/notifications';
import { MUTATION_KEYS } from 'utils/queryKeys';
import { getErrorMessage } from 'utils/getErrorMessage';

export const useDeleteHardware = (
  onSuccess: () => void,
): UseMutationResult<SerializedHardware, unknown, DeleteHardwareArg> => {
  const { hardwaresApiClient } = useServices();

  return useMutation((arg: DeleteHardwareArg) => hardwaresApiClient.delete(arg), {
    mutationKey: MUTATION_KEYS.hardwares.deleteOne(),
    onError: error => {
      notifyError(error, {
        message: 'There was an error while deleting hardware',
        description: getErrorMessage(error),
      });
    },
    onSuccess: () => {
      notifySuccess({
        message: `Hardware deleted`,
      });
      onSuccess();
    },
  });
};
